"use client";

import { AnchorHTMLAttributes, PropsWithChildren } from "react";

/** Renders a native anchor for full-document navigation across shell/zone boundaries. */
export const HardNavigationLink = ({
  children,
  href,
  onClick,
  ...props
}: PropsWithChildren<
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & { href: string }
>) => {
  return (
    <a href={href} onClick={onClick} {...props}>
      {children}
    </a>
  );
};
